<template>
  <div class="container bg-gray-100 mb-5 p-3">
    <router-link type="button" class="hover:underline block text-left" to="/">
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
    </router-link>
    <div class="container bg-white rounded-lg p-3 box-shadow">
      <p class="text-gray-700 text-center text-2xl lg:text-4xl">
        Contactar a un asesor
      </p>
      <p class="text-gray-600 text-center text-lg lg:text-xl">
        Su información será enviada y a la brevedad un asesor se estará
        contactando con usted.
      </p>

      <form
        autocomplete="off"
        @submit.prevent="onSubmit()"
        class="flex flex-wrap"
      >
        <label class="mt-3 mb-2">RFC:*</label>
        <input
          type="text"
          v-model="rfc"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          maxlength="13"
          minlength="13"
          pattern="[a-zA-Z0-9]{13,13}"
          title="RFC debe tener 13 caracteres, sin espacios ni caracteres especiales"
          oninput="this.value = this.value.toUpperCase();"
          required
        />

        <label class="mt-3 mb-2">Nombre:*</label>
        <input
          type="text"
          v-model="name"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          maxlength="30"
          minlength="2"
          pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
          title="Nombre debe tener un máximo de 30 caracteres, sin espacios ni caracteres especiales"
          oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
          required
        />

        <label class="mt-3 mb-2">Apellido:*</label>
        <input
          type="text"
          v-model="paternalLastName"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          maxlength="30"
          minlength="2"
          pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
          title="Apellido debe tener un máximo de 30 caracteres, sin espacios ni caracteres especiales"
          oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
          required
        />

        <label class="mt-3 mb-2">Número de teléfono:*</label>
        <input
          type="text"
          v-model="phone"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          v-maska="'###-###-####'"
          title="Debe tener 10 dígitos"
          maxlength="13"
          minlength="13"
          pattern="[0-9]{3}[-][0-9]{3}[-][0-9]{4}"
          required
        />

        <!-- <div class="input w-full lg:w-1/3 md:w-1/2">
                <label>Número de tarjeta</label>
                <input
                v-model="tarjeta"
                class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
                type="text" 
                onchange="this.setCustomValidity('')" 
                oninvalid="this.setCustomValidity('Debe tener 16 dígitos.')" 
                title="Debe tener 16 dígitos." 
                v-maska="'####-####-####-####'" 
                placeholder="####-####-####-####" 
                />
            </div> -->

        <label class="mt-3 mb-2"> Correo electrónico:* </label>
        <input
          v-model="email"
          type="email"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          required
          oninput="this.value = this.value.toLowerCase();"
        />

        <label class="mt-3 mb-2"> Sección:* </label>
        <v-select
          :searchable="false"
          v-model="selectedSection"
          class="w-full shadow-md appearance-none border rounded text-grey-darker"
          :options="selectSectionOptions"
          :placeholder="'Seleccione una sección'"
        >
          <template v-slot:no-options>
            <template> No hay resultados. </template>
          </template>
        </v-select>
        <span v-if="optionSectionSelected" class="text-red-600 text-xs"
          >Seleccione una sección</span
        >

        <div v-if="selectedSection" class="w-full mt-2">
          <label v-if="selectedSection.value" class="mb-2">
            Coordinación:*
          </label>
          <v-select
          :searchable="false"
            v-if="selectedSection.value"
            v-model="selectedCoordination"
            class="w-full shadow-md appearance-none border rounded text-grey-darker"
            :options="selectCoordinationOptions"
            :placeholder="'Seleccione una coordinación'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
          <span
            v-if="!optionSectionSelected && optionCoordinationSelected"
            class="text-red-600 text-xs"
            >Seleccione una coordinación</span
          >
        </div>

        <label class="mt-3 mb-2">
          ¿En que cobertura(s) estás interesado/a?
        </label>
        <v-select
        :searchable="false"
          v-model="selectedCoverage"
          taggable
          multiple
          class="w-full shadow-md appearance-none border rounded text-grey-darker"
          :options="coverages"
        >
          <template v-slot:no-options>
            <template> No hay resultados. </template>
          </template>
        </v-select>
        <span v-if="optionCoverageSelected" class="text-red-600 text-xs w-full"
          >Seleccione al menos una cobertura</span
        >

        <label class="mt-3 mb-2"> Agregar comentario: </label>
        <textarea
          v-model="commentary"
          name="textarea"
          rows="5"
          class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
          oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
          required
        >
        </textarea>

        <div class="w-full p-2 text-center mt-5 mb-2">
          <button
            class="w-full flex justify-center items-center mx-auto  md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-4 px-6 rounded"
          >
            Contactar <mdicon name="chevron-right" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";

export default {
  name: "Quotation",

  data() {
    return {
      reference: null,
      rfc: null,
      name: null,
      paternalLastName: null,
      phone: null,
      email: null,
      sections: [],
      errorSection: false,
      selectedSection: [],
      coordinations: [],
      errorCoordination: false,
      selectedCoordination: [],
      coverages: [
        "Accidentes Personales",
        "Indemnización por Cáncer",
        "Respaldo Hospitalario",
        "Indemnización por Enfermedades Graves",
        "Pérdida de Ingresos",
      ],
      selectedCoverage: [],
      errorCoverage: false,
      commentary: null,
      validateInfo: false,
      api_lineamagisterialproducts: process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      myOptions: {
        size: {
          fontSize: 0.8,
          height: 3,
          padding: 0.2,
          width: 15,
        },
        items: {
          delay: 0.4,
          preSelected: "unknown",
          disabled: false,
          labels: [
            {
              name: "Cotizar para mí",
              color: "white",
              backgroundColor: "gray",
            },
            {
              name: "Cotizar para dependiente",
              color: "white",
              backgroundColor: "gray",
            },
          ],
        },
      },
    };
  },
  created() {
    // console.log(jsonSections)
    // console.log(jsonSections[0].coordinations)
    this.getSections();
    this.getDataFromLocalStore();
  },
  methods: {
    getSections() {
      axios
        .get(this.api_lineamagisterialproducts+"/business/get_all", {})
        .then((response) => {
          this.sections = response.data.result;
        });
    },
    getDataFromLocalStore() {
      this.reference = localStorage.reference;
      console.log("REFERENCE", this.reference);
    },
    onSubmit() {
      this.getDataFromLocalStore();
      this.validateBlankInputs();
      this.SetUpperCase();
      if (this.validateInfo == true) {
        this.registerContactRequest();
      } else {
        this.validateBlankInputs();
      }
    },

    validateBlankInputs() {
      if (this.selectedSection.value == null) {
        this.errorSection = true;
      }
      if (this.selectedCoordination.value == null) {
        this.errorCoordination = true;
      }
      if (this.selectedCoverage.length < 1) {
        this.errorCoverage = true;
      }
      if (
        this.errorSection == false &&
        this.errorCoordination == false &&
        this.errorCoverage == false
      ) {
        this.validateInfo = true;
      }
    },
    registerContactRequest() {
      axios
        .post(
          this.api_lineamagisterialproducts+"/contact_request/register",
          {
            contact_request: {
              rfc: this.rfc,
              first_name: this.name,
              paternal_lastname: this.paternalLastName,
              lada_phone: this.phone.replace(/\D+/g, "").substring(0, 3),
              phone_number: this.phone.replace(/\D+/g, "").substring(3, 10),
              email: this.email,
              comments: this.commentary,
              coordination: this.selectedCoordination.label,
              interested: {
                coberturas: this.selectedCoverage,
              },
              postal_code: "",
            },
            reference_code: this.reference,
          }
        )
        .then((response) => {
          Swal.fire(
            "Se ha contactado con un asesor",
            "Un asesor se contactará con usted a la brevedad.",
            "success"
          );
          console.log("Se ha enviado correctamente", response);
          this.$router.push({ name: "home" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SetUpperCase() {
      this.name =
        this.name.substr(0, 1).toUpperCase() + this.name.substr(1, this.length);
      this.paternalLastName =
        this.paternalLastName.substr(0, 1).toUpperCase() +
        this.paternalLastName.substr(1, this.paternalLastName.length);
      this.commentary =
        this.commentary.substr(0, 1).toUpperCase() +
        this.commentary.substr(1, this.commentary.length);
    },
  },

  computed: {
    optionSectionSelected() {
      if (this.selectedSection.value > 0 && this.errorSection == true) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.errorSection = false;
        return this.errorSection;
      }
      return this.errorSection;
    },
    optionCoordinationSelected() {
      if (this.selectedSection) {
        if (this.selectedSection.value > 0) {
          if (
            this.selectedCoordination.value > 0 &&
            this.errorCoordination == true
          ) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errorCoordination = false;
            return this.errorCoordination;
          }
        }
      }

      return this.errorCoordination;
    },
    optionCoverageSelected() {
      if (this.selectedCoverage.length > 0 && this.errorCoverage == true) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.errorCoverage = false;
        return this.errorCoverage;
      }
      return this.errorCoverage;
    },
    selectSectionOptions() {
      return this.sections.map((sections) => ({
        label: sections.section,
        value: sections.id,
      }));
    },
    selectCoordinationOptions() {
      return this.sections[this.selectedSection.value - 1].coordinations.map(
        (coordinations) => ({
          label: coordinations.municipality,
          value: coordinations.id,
        })
      );
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>